// TextArea.jsx
import React from "react";

export default function TextArea({
  label,
  helper,
  error,
  rows = 3,
  className = "",
  ...props
}) {
  const ACCENT = "#169FA7";

  return (
    <div className={className}>
      {label && (
        <label className="block text-sm font-medium text-neutral-700 dark:text-neutral-300 text-start mb-1">
          {label}
        </label>
      )}
      <textarea
        rows={rows}
        {...props}
        className={[
          "w-full rounded-2xl px-3 py-2",
          "bg-white dark:bg-neutral-900",
          "border border-neutral-200 dark:border-neutral-800",
          "text-neutral-900 dark:text-neutral-100 placeholder:text-neutral-400 placeholder:text-sm text-sm",
          "focus:outline-none focus:ring-.5 focus:ring-[--ring] focus:border-[--ring]",
        ].join(" ")}
        style={{ "--ring": ACCENT }}
      />
      {helper && !error && (
        <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400 text-start">
          {helper}
        </p>
      )}
      {error && (
        <p className="mt-1 text-xs text-rose-600 dark:text-rose-400 text-start">
          {error}
        </p>
      )}
    </div>
  );
}
